"use client";

import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";

/**
 * 寸法は Figma (fileKey=TC2XGjmXK1Doz6wYvh1P0w, node=7622:52222) の実測値。
 * 常時表示でも Base UI は登録済み Trigger を anchor に位置解決するため、不可視の Trigger を置く。
 */
export function CheckoutTooltip({ message }: { message: string }) {
  return (
    <TooltipPrimitive.Root open>
      <TooltipPrimitive.Trigger
        render={
          <span
            aria-hidden
            className="pointer-events-none absolute top-0 left-1/2 h-0 w-0 -translate-x-1/2"
          />
        }
      />
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Positioner
          side="top"
          sideOffset={8}
          // Portal は body 直下に出るため、Drawer (z-50) の背後に隠れないよう上回る値にする。
          className="pointer-events-none isolate z-[60]"
        >
          {/* open 固定だと data-starting-style がマウント時に発火しないため、animation でフェードインさせる */}
          <TooltipPrimitive.Popup className="bg-dx-bg-inverse text-dx-text-inverse animate-tooltip-fade-in w-fit rounded-[4px] px-[12px] py-[8px] text-center text-[12px] leading-[16px] font-normal whitespace-nowrap drop-shadow-[0px_6px_7px_rgba(0,0,0,0.1),0px_0px_0px_rgba(0,0,0,0.02)]">
            {message}
            <TooltipPrimitive.Arrow className="bg-dx-bg-inverse fill-dx-bg-inverse size-[10px] rotate-45 rounded-[2px] data-[side=bottom]:-top-[4px] data-[side=top]:-bottom-[4px]" />
          </TooltipPrimitive.Popup>
        </TooltipPrimitive.Positioner>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
